var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UnidataEditorBasicMultiple',{attrs:{"stores":['_geometryModule','_geometryModule'],"getters":['highPlate','lowPlate'],"title":'TRNSL237',"actions":['SET_HIGH_PLATE','SET_LOW_PLATE'],"min":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }